export const menuList: LinkProp[] = [
  {
    name: "网站首页",
    link: "/",
    children: [],
  },
  {
    name: "机构概况",
    link: "/institution",
    children: [
      {
        name: "本馆介绍",
        link: "/institution/introduction",
        children: [],
      },
      {
        name: "机构设置",
        link: "/institution/profile",
        children: [],
      },
    ],
  },
  {
    name: "馆务信息",
    link: "/information",
    children: [
      {
        name: "工作动态",
        link: "/information/dynamic",
        children: [],
      },
      {
        name: "通知公告",
        link: "/information/notify",
        children: [],
      },
    ],
  },

  {
    name: "档案文化",
    link: "/culture",
    children: [
      {
        name: "档案展览",
        link: "/culture/display",
        children: [],
      },
      {
        name: "专题图片",
        link: "/culture/picture",
        children: [],
      },
      {
        name: "档案阅读",
        link: "/culture/read",
        children: [],
      },
      {
        name: "史海钩沉",
        link: "/culture/history",
        children: [],
      },
      {
        name: "视频荟萃",
        link: "/culture/video",
        children: [],
      },
    ],
  },

  {
    name: "档案查询",
    link: "/archive",
    children: [
      {
        name: "查档指南",
        link: "/archive/guide",
        children: [],
      },
      {
        name: "查档预约",
        link: "/archive/prebook",
        children: [],
      },
      {
        name: "预约回复",
        link: "/archive/reply",
        children: [],
      },
      {
        name: "开放目录",
        link: "/archive/open",
        children: [],
      },
      {
        name: "原文档案",
        link: "/archive/origin",
        children: [],
      },
    ],
  },
  {
    name: "公众参与",
    link: "/people",
    children: [
      {
        name: "咨询投诉",
        link: "/people/advice",
        children: [],
      },
      {
        name: "档案捐赠",
        link: "/people/donation",
        children: [],
      },
      {
        name: "满意度评价",
        link: "/people/satisfaction",
        children: [
          //   {
          //     name: "意见详情",
          //     link: "/people/detail",
          //     children: [],
          //   },
        ],
      },
      {
        name: "资料下载",
        link: "/people/download",
        children: [],
      },
    ],
  },
];

export type LinkProp = {
  name: string;
  link: string;
  children?: LinkProp[];
  //   redirect?: string;
};

const flattenMenuList: LinkProp[] = [];

function flatArray(list: LinkProp[], flattenMenuList: LinkProp[]) {
  list.forEach((item) => {
    flattenMenuList.push(item);
    if (item?.children?.length) {
      flatArray(item.children, flattenMenuList);
    }
  });
}

function getMainMenu(list: LinkProp[]) {
  return list.map((m) => (m.children?.length ? m.children[0] : m));
}

flatArray(menuList, flattenMenuList);

const mainMenuList = getMainMenu(menuList);

const categoryMap = Object.fromEntries(
  flattenMenuList.map((item) => [item.link, item.name])
);

const categoryNameLinks = Object.fromEntries(
  flattenMenuList.map((item) => [item.name, item.link])
);

export { mainMenuList, flattenMenuList, categoryMap, categoryNameLinks };

export const quickEntry = [
  {
    name: "查档指南",
    link: "/archive/guide",
  },
  {
    name: "查档预约",
    link: "/archive/prebook",
  },
  {
    name: "开放目录",
    link: "/archive/open",
  },
  {
    name: "原文档案",
    link: "/archive/origin",
  },
  {
    name: "档案捐赠",
    link: "/people/donation",
    children: [],
  },
  {
    name: "咨询投诉",
    link: "/people/advice",
  },
];
